import { render, staticRenderFns } from "./BarcodePrint.vue?vue&type=template&id=5b5744ba"
import script from "./BarcodePrint.vue?vue&type=script&lang=js"
export * from "./BarcodePrint.vue?vue&type=script&lang=js"
import style0 from "./BarcodePrint.vue?vue&type=style&index=0&id=5b5744ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports